var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/core-js/modules/_has.js
// module id = ../../../../core-js/modules/_has.js
// module chunks = 1